export const defaultColorGridValue = () => {
    return {
      styles: { width: 400, height: 400 },
      box_styles: {
        border_color: "black",
        bg_color: "#656d4a",
        border_width: 1,
      },
      num_rows: 0,
      num_columns: 0,
      answer: null,
      is_answer_rectangle: null
    };
}

